import $ from 'jquery';

const categoryTabs = {
    config: {
        tabSelector: '#tabStrip',
        tabContainer: 'div.cat_tab_panel',
        tabClass: '.category_tabs',
        revealMore: '.seeMore'
    },
    categoryTab: null,
    tabContainers: null,
    revealMore: null,

    initTabs: function(options) {
        categoryTabs.config = $.extend({}, categoryTabs.config, options);
        categoryTabs.categoryTab = $(categoryTabs.config.tabSelector);
        categoryTabs.tabContainers = $(categoryTabs.config.tabContainer);
        categoryTabs.addIDsToTabs();
        categoryTabs.bindMoreClick();
        categoryTabs.bindTabClick();
        categoryTabs.displayTabFromHash();
    },

    initCategory: function() {
        categoryTabs.formatSubCategoryLastChildren();
        categoryTabs.bindMoreClick();
    },

    displayTabFromHash: function() {
        //allow URL hash to expose given Tab, hash = tab ID:
        var hashTab = window.location.hash,
            $tabStrip = $('#tabStrip'),
            $liveElement;

        if (hashTab.substr(0, 2) === '#/') {
            return;
        }

        if (hashTab.length > 1) {
            $liveElement = $tabStrip.find('a' + hashTab + '_tab');
            if ($liveElement.length > 0) {
                $liveElement.trigger('click');
                window.scrollTo(0, $tabStrip.offset().top);
            } else {
                categoryTabs.categoryTab
                    .find('a')
                    .filter(':first')
                    .trigger('click');
            }
        } else {
            categoryTabs.categoryTab
                .find('a')
                .filter(':first')
                .trigger('click');
        }
    },

    bindTabClick: function() {
        categoryTabs.categoryTab.on('click', 'a', function(e) {
            e.preventDefault();
            return false;
        });
    },

    _getContentDivIdFromClickedTab: function(clicked) {
        var _tab = 4,
            contentDivId = clicked.substr(0, clicked.length - _tab);
        return contentDivId;
    },

    handleTabClick: function(event) {
        var $clicked = $(event.currentTarget),
            clickedID = categoryTabs._getContentDivIdFromClickedTab($clicked.attr('id')),
            thisTab = $clicked.closest('li');

        if (thisTab.hasClass('selected')) {
            return;
        }

        categoryTabs.tabContainers.hide();
        $('div#' + clickedID).show();
        categoryTabs.categoryTab.find('li').removeClass('selected');
        thisTab.addClass('selected');
        thisTab.trigger({type: 'swapTab', clicked: $clicked});
    },

    cleanEndOfString: function(txt, character) {
        return txt.substr(-1) === character ? txt.substr(0, txt.length - 1) : txt;
    },

    addIDsToTabs: function() {
        categoryTabs.categoryTab.find('a').each(function(index, element) {
            var $self = $(element),
                aName = $self.attr('href').substr(1);
            aName = categoryTabs.cleanEndOfString(aName, ')') + '_tab';
            $self.attr('id', aName);
        });
    },

    // FOR NON PRODUCT COMPARE CATEGORY PAGES [ 'c' pages ]:

    handleMoreClick: function(event) {
        var $clicked = $(event.target),
            $moreElements = $clicked
                .parent()
                .parent()
                .find('.more'),
            $lastVisible = $moreElements.first().prev();

        $lastVisible.text($lastVisible.text().trim() + ', ');
        $moreElements.removeClass('more');
        $clicked.hide();
    },

    bindMoreClick: function() {
        $(categoryTabs.config.revealMore).on('click', 'a', function(e) {
            e.preventDefault();
            categoryTabs.handleMoreClick(e);
        });
    },

    formatSubCategoryLastChildren: function() {
        $('.subcategory').each(function(index, element) {
            var $current = $(element),
                $lastLI = $current
                    .find('li:first')
                    .nextUntil('.more')
                    .last(),
                $lastLiLink = $lastLI.find('a'),
                aText = categoryTabs.cleanEndOfString($lastLiLink.text().trim(), ','),
                $lastMoreLI = $current.find('.more').last(),
                $lastMoreLILink = $lastMoreLI.find('a'),
                lastMoreText = categoryTabs.cleanEndOfString($lastMoreLILink.text().trim(), ',');

            $lastLiLink.text(aText);
            $lastMoreLILink.text(lastMoreText);
        });
    }
};

export default categoryTabs;
